import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'userAddressListPopup-popover',
  templateUrl: 'userAddressListPopup.html',
  styleUrls: ['userAddressListPopup.scss'],

})

export class userAddressListPopup implements OnInit {

 
  public userAddressList: any;
  public userAddressListCopy: any;
  


  constructor(public navParams: NavParams, private popoverController: PopoverController) {
  }

  ngOnInit() {

    this.userAddressList = this.navParams.data.userAddressList;
    this.userAddressListCopy = this.navParams.data.userAddressList;
    
  }

  searchAddress(search) {
    const term = (search || "").toString().toLowerCase().trim();
    this.userAddressList = this.userAddressListCopy;
    if (!term) {
      return;
    }

    this.userAddressList = this.userAddressList.filter(item => {
      const address1 = (item.address1 || "").toLowerCase();
      const address2 = (item.address2 || "").toLowerCase();
      const city = (item.city || "").toLowerCase();
      const state = (item.state || "").toLowerCase();
      const zip = (item.zip || "").toString().toLowerCase();
      return address1.includes(term) || address2.includes(term) || city.includes(term) || state.includes(term) || zip.includes(term);
    });
  }

  addToCartClicked(userAddress) {
    this.popoverController.dismiss(userAddress);
  }

}

